var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"widget-1",attrs:{"bordered":true,"loading":_vm.loading}},[_c('a-statistic',{staticClass:"text-success",attrs:{"title":_vm.title,"value":_vm.value},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_c('a-icon',{staticStyle:{"padding-right":"10px"},attrs:{"type":_vm.icon}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }